import React from 'utils/react';

import Header from 'components/Header';
import Layout from 'components/Layout';

import Container from './Container';
import Table from './Table';
import Panel from './Panel';
import Compare from './Compare';
import { useEffect } from 'react';

const Simulations = ({ list, page, projectId, fetchSimulations }) => {
  useEffect(() => {
    if ((!list || !page) && projectId) {
      fetchSimulations();
    }
  }, [page]);

  return (
    <Layout hasBackground>
      <Container>
        <Header />
        <Panel />
        <Table />
        <Compare />
      </Container>
    </Layout>
  );
};

export default Simulations;
